import BstlArtikel from "./bstl_artikel"

export default class ReservierungVorbestellungPending {
    id: string
    reservierungId: string
    bestellZp: string
    artikelliste: BstlArtikel[] = []
}